var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Headers'),_c('router-view',{staticStyle:{"width":"1200px","min-height":"820px","margin":"0 auto"}}),_c('Footers')],1)}
var staticRenderFns = []

export { render, staticRenderFns }